import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { Module } from 'vuex'
import { State } from '@/store/store'
import { MapState } from './states'

const CustomMap: Module<MapState, State> = {
  state: new MapState(),
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default CustomMap
